// auditor-routes.tsx
import AuditorLayout from './pages/auditor-view/components/AuditorLayout';
import AuditorAssuranceLibrary from './pages/auditor-view/assurance-library';
import AuditorView from './pages/auditor-view';
import AuditorSOA from './pages/auditor-view/soa';
import AuditorRiskRegister from './pages/auditor-view/risk-register';
import AuditorRiskDetail from './pages/auditor-view/risk-detail';
import AuditorAssetRegister from './pages/auditor-view/asset-register';
import AuditorMSG from './pages/auditor-view/msg';
import AuditorDocumentLibrary from './pages/auditor-view/document-library';
import AuditorPolicyAdmin from './pages/auditor-view/policy';
import AuditorAssetDetail from './pages/auditor-view/asset-detail';
import AuditorDocumentDetail from './pages/auditor-view/document-detail';
import { Navigate } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';

export const auditorRoutePaths = {
  'auditor-view': '/auditor-view',
  'auditor-view.soa': '/auditor-view/soa',
  'auditor-view.risk-register': '/auditor-view/risk-register',
  'auditor-view.risk-detail': '/auditor-view/risk-detail/:id',
  'auditor-view.asset-register': '/auditor-view/asset-register',
  'auditor-view.asset-detail': '/auditor-view/asset-detail/:id',
  'auditor-view.assurance-library': '/auditor-view/assurance-library',
  'auditor-view.document-library': '/auditor-view/document-library',
  'auditor-view.document-detail': '/auditor-view/document-detail/:id',
  'auditor-view.policy': '/auditor-view/policy',
  'auditor-view.msg': '/auditor-view/msg',
  'auditor-view.msg.wildcard': '/auditor-view/msg/*',
};

export const auditorRoutes = [
  { name: 'auditor-view', path: auditorRoutePaths['auditor-view'], element: <AuditorView /> },
  { name: 'auditor-view.soa', path: auditorRoutePaths['auditor-view.soa'], element: <AuditorSOA /> },
  { name: 'auditor-view.risk-register', path: auditorRoutePaths['auditor-view.risk-register'], element: <AuditorRiskRegister /> },
  { name: 'auditor-view.risk-detail', path: auditorRoutePaths['auditor-view.risk-detail'], element: <AuditorRiskDetail /> },
  { name: 'auditor-view.asset-register', path: auditorRoutePaths['auditor-view.asset-register'], element: <AuditorAssetRegister /> },
  { name: 'auditor-view.asset-detail', path: auditorRoutePaths['auditor-view.asset-detail'], element: <AuditorAssetDetail /> },
  { name: 'auditor-view.assurance-library', path: auditorRoutePaths['auditor-view.assurance-library'], element: <AuditorAssuranceLibrary /> },
  { name: 'auditor-view.document-library', path: auditorRoutePaths['auditor-view.document-library'], element: <AuditorDocumentLibrary /> },
  { name: 'auditor-view.document-detail', path: auditorRoutePaths['auditor-view.document-detail'], element: <AuditorDocumentDetail /> },
  { name: 'auditor-view.policy', path: auditorRoutePaths['auditor-view.policy'], element: <AuditorPolicyAdmin /> },
  { name: 'auditor-view.msg', path: auditorRoutePaths['auditor-view.msg'], element: <AuditorMSG /> },
  { name: 'auditor-view.msg.wildcard', path: auditorRoutePaths['auditor-view.msg.wildcard'], element: <AuditorMSG /> },
  { name: 'auditor-view.catchall', path: '/auditor-view/*', element: <Navigate to="/auditor-view" replace /> },
];

export function AuditorRoutesWithLayout() {
  return (
    <AuditorLayout>
      <Routes>
        {auditorRoutes.map(({ name, path, element }) => (
          <Route key={name} path={path} element={element} />
        ))}
      </Routes>
    </AuditorLayout>
  );
}
